module.exports = __webpack_public_path__ + "static/young_black_dragon-b495cebae5bfd633901ea8d7f28218f5.jpg";